module.exports = __webpack_public_path__ + "static/media/gameboy.2ca94b9c.svg";